
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class CompanyQueryModel extends Model<CompanyQueryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'keyword', type: 'string', languageString: 'companyQuery.property.keyword' },
		{ name: 'vatNumber', type: 'string', languageString: 'companyQuery.property.vatNumber' },
		{ name: 'nace', type: 'number', languageString: 'companyQuery.property.nace' },
		{ name: 'businessName', type: 'string', languageString: 'companyQuery.property.businessName' },
		{ name: 'phoneNumber', type: 'string', languageString: 'companyQuery.property.phoneNumber' },
		{ name: 'zipCode', type: 'string[]', languageString: 'companyQuery.property.zipCode', isArray: true }
	];
	[key: string]: any;
	
	public keyword: string;
	public vatNumber: string;
	public nace?: number;
	public businessName: string;
	public phoneNumber: string;
	public zipCode: string[];
    
	constructor(){
		super();
		this.keyword = '';
		this.vatNumber = '';
		this.nace = undefined;
		this.businessName = '';
		this.phoneNumber = '';
		this.zipCode = [];
		
	}
	getProperties(){
		return CompanyQueryModel.classProperties;
	}
}

